module.exports = __webpack_public_path__ + "img/rBox.cbfbf981.png";